import { Repository } from '../dbservices/repo';

class CompanyMenuService {
  constructor() {
    this.collectionName = 'companymenu';
  }

  // Use a getter to safely access currentUser
  get currentUser() {
    // 1. Safety check for SSR/Next.js
    if (typeof window === 'undefined') return null;
    
    const data = localStorage.getItem('userData');
    try {
      return data ? JSON.parse(data) : null;
    } catch (e) {
      console.error("Failed to parse userData from localStorage", e);
      return null;
    }
  }

  async fetchCompanyMenuItems() {
    const user = this.currentUser;
    // 2. Guard clause: Ensure user exists before using properties
    if (!user || !user.companyCode || !user.unitCode) {
      console.error("fetchCompanyMenuItems: User data is missing or invalid");
      return [];
    }

    const filters = [
      { field: 'companyCode', value: user.companyCode },
      { field: 'unitCode', value: user.unitCode }
    ];

    const repoInstance = new Repository();
    const rawData = await repoInstance.fetchData('companymenu', filters);

    return (rawData || []).map(docData => ({
      ...docData,
    })).sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
  }

  async isItemInOpenOrders(itemCode, companyCode) {
    try{
    const repoInstance = new Repository();
    const openOrders = await repoInstance.fetchData('orders', [
      { field: 'companyCode', value: companyCode },
      { field: 'orderStatus', value: 'Open' }
    ]);
    
    return (openOrders || []).some(order => 
      (order.items || []).some(item => item.itemCode === itemCode)
    );
  }catch(error){
    return false; // Assume not in use if we can't fetch orders
  }

   

    
  }

  async deleteMenuItem(id) {
    
    const repoInstance = new Repository();
    console.log("Fetching item with collection:", this.collectionName, "and ID:", id);

  let itemToDelete;
  try {
     
    itemToDelete = await repoInstance.fetchById(this.collectionName, id);
   
    // DEBUG LOG 2: Check what came back from the DB
    console.log("Database result:", itemToDelete);
  } catch (error) {
    console.error("Database fetch failed entirely:", error);
    throw error;
  }

  if (!itemToDelete) {
    console.log(`Item with ID ${id} not found. Cannot delete.`); 
    throw new Error("Item not found"); // 🛑 Control stops here if item is null!
  }
 
     
  
    // 3. Pass the actual companyCode, not 'this'
    const isUsed = await this.isItemInOpenOrders(itemToDelete.itemCode, itemToDelete.companyCode);
    
    if (isUsed) {
      throw new Error("Cannot delete: This item is currently used in an open order.");
    }
    
    await repoInstance.deleteData(this.collectionName, id);
    await repoInstance.removeFromCache(this.collectionName, id);
    
    return { success: true };
  }

  subscribeToMenuUpdates(callback) {
    const user = this.currentUser;
    if (!user) {
      console.error("Cannot subscribe: User data not found");
      return;
    }

    const filters = [
      { field: 'companyCode', value: user.companyCode },
      { field: 'unitCode', value: user.unitCode }
    ];
    
    const repoInstance = new Repository();
    return repoInstance.subscribeToUpdates(this.collectionName, filters, callback);
  }
}

export const menuService = new CompanyMenuService();